export const dependencyEn = {
  dependsOn: 'Depends on tasks (Timeline)',
  dependent: 'Dependent tasks (Timeline)',
  addDependsOn: 'Add dependency',
  addDependent: 'Add dependent task'
}

export const dependencyRu: typeof dependencyEn = {
  dependsOn: 'Зависит от задач (Гант)',
  dependent: 'Зависимые задачи (Гант)',
  addDependsOn: 'Добавить зависимость',
  addDependent: 'Добавить зависимую задачу'
}
